export const addDecimalToICDCodeIfNeeded = (code: string = ''): string => {
  return code.length > 3 ? code.slice(0, 3) + '.' + code.slice(3) : code;
};
